import _isString from 'lodash/isString';
export function truncateParagraphs(text, numParagraphs) {
  if (!_isString(text)) {
    return text;
  }
  var paragraphs = text.split('\n');
  var indexToTruncate = 0;
  var numValidParagraphs = 0;
  paragraphs.forEach(function (paragraph) {
    if (numParagraphs === numValidParagraphs) {
      return;
    }
    if (paragraph.trim().length > 0) {
      numValidParagraphs += 1;
      indexToTruncate += 1;
    } else {
      indexToTruncate += 1;
    }
  });
  return paragraphs.slice(0, indexToTruncate).join('\n');
}